import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader, Center, Text, Button } from "@mantine/core";
import { confirmInvoicepayment } from "../../services/payment";
import { baseURL, frontendURL } from "../../http";

const Success = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   console.log('in the payment effect');
  //   const queryParameters = new URLSearchParams(window.location.search)

  //   const sessionId = queryParameters.get('session_id')
  //   console.log('sessionId',sessionId);

  //   if (sessionId) {
  //  let response=  confirmInvoicepayment({sessionId});

  //  if (response.status === 200){
  //   const url = "https://staging.ogiso.io";

  //   window.location.href = url;
  //  }
  //   }
  // }, [navigate])

  // useEffect(() => {
  //   // console.log('in the payment effect');
  //   // console.log('Window Location Search:', window.location.search);
  //   const queryParameters = new URLSearchParams(window.location.search);
  //   // console.log('queryParameters',queryParameters);

  //   const paymentIntentid = queryParameters.get("payment_intent");

  //   if (paymentIntentid) {
  //     let response = await confirmInvoicepayment({ paymentIntentid });

  //     console.log('response',response);
      

  //     if (response?.status === 200) {
  //       setLoading(false);
  //       // const url = frontendURL;

  //       // window.location.href = url;
  //     }
  //   }
  // }, [navigate]);
  useEffect(() => {
    const handlePaymentConfirmation = async () => {
      const queryParameters = new URLSearchParams(window.location.search);
      const paymentIntentid = queryParameters.get("payment_intent");
  
      if (paymentIntentid) {
        try {
          let response = await confirmInvoicepayment({ paymentIntentid });
          console.log('response', response);
  
          if (response?.status === 200) {
            setLoading(false);
         
          }
        } catch (error) {
          console.error('Error confirming payment:', error);
       
        }
      }
    };
  
    handlePaymentConfirmation();
  }, [navigate]);
  

  return (
    <Center style={{ flexDirection: "column", minHeight: "100vh" }}>
      {loading ? (
        <>
          <Text size="xl" style={{ marginBottom: "20px" }}>
            Processing Payment
          </Text>
          <Loader size="xl" />
          <Text size="lg" style={{ marginTop: "20px", marginBottom: "20px" }}>
            Please wait while we process your payment...
          </Text>
        </>
      ) : (
        <>
          <Text size="xl" style={{ marginBottom: "20px" }}>
            Payment Successfull
          </Text>

          <img
          style={{ marginBottom: "20px" }}
            src="/assets/images/greenCheck.png"
            width={50}
            alt="green check mark"
          />
        </>
      )}

      {/* <Button
        c={"#000"}
        color="yellow"
        onClick={() => {
          window.open(frontendURL, "_blank");
        }}
      >
        Back to Home
      </Button> */}
    </Center>
  );
};

export default Success;